<div>
    <label class="labelBlack">{{titleValue.title | translate}}</label>
    <div class="w-100"></div>
    <label class="headerBig mt-1 mb-0" [innerText]="titleValue.value | translate"> </label>
    <div class="w-100"></div>
    <label class="text-label-small">{{titleValue.subtitle | translate}}</label>
</div>